export default "/images/mini-cross.png?cd0923ecc5caa098f10cb8a79eb060e4";